// src/components/AdSlot.jsx
import { useEffect, useRef } from "react";

const AdSlot = ({
  slot = "2729446592",       // default slot ID
  style = {},
  className = "",
  format = "auto",
  responsive = "true",
}) => {
  const adRef = useRef(null);

  useEffect(() => {
    if (!window.adsbygoogle) return;

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.warn("AdSense error:", e);
    }
  }, []);

  return (
    <div className={`my-4 flex justify-center ${className}`}>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: "block", ...style }}
        data-ad-client="ca-pub-1735112471509214"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive}
      />
    </div>
  );
};

export default AdSlot;